<script>
  import resources from './resources'

  export default {
    name: 'gadget-seletor-dates-professional',
    mixins: [resources]
  }
</script>

<template lang="pug">
  section.gadget-seletor-datas.white-bg.wrapper.full-width.gadget
    .gadget-title
      | Seletor de Datas
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .col-xs-12.col-md-4
      .form-group
        label.light-red(for='data-de-agendamentos') Selecione a Data dos Agendamentos
        .input-group
          input#data-de-agendamentos.form-control(type='num', placeholder='dd/mm/aaaa', data-provide='datepicker')
          span.input-group-addon.blue-addon
            span.icon 
    .col-xs-12.col-sm-6.col-md-3.col-md-offset-1
      .form-group
        label.light-red(for='semana') Semana
        .input-group
          select#semana.form-control(name='semana')
            option(value='proxima-anterior') Próxima, Anterior
          span.input-group-addon.blue-addon
            span.icon 
    .col-xs-12.col-sm-6.col-md-3.col-md-offset-1
      .form-group
        label.light-red(for='mes') Mês
        .input-group
          select#mes.form-control(name='mes')
            option(value='proxima-anterior') Próximo, Anterior
          span.input-group-addon.blue-addon
            span.icon 
</template>


// WEBPACK FOOTER //
// src/app/employee/dashboard/gadget/components/select-dates/dates.vue